import { HttpClaimOrderList, HttpExportClaimOrder } from '@/service/salesreturns';
import TableList from "@components/templates/tablelist";
import { mapGetters } from 'vuex';
import compDetail from './detail';
import mixin from '../mixin';
export default {
    mixins: [TableList, mixin],
    components: {
        compDetail
	},
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Searchs: {
                show: true,
                labelWidth: 110,
            },
            Plugins: { show: true },
            formData: {},
        };
    },
    methods: {
        ajaxRequest: HttpClaimOrderList,
        handleOperates(params, type) {
            switch (type) {
                case 'export':
                    this.handleWebfs(HttpExportClaimOrder, this.formData, { executor: 'request', download: true });
                    break;
                case "query":
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 1200,
                        component: "compDetail",
                        activeids: params,
                        showFooter: false
                    }
                    break;
                case "queryBlank":
                    var url = this.$router.resolve({
                        name: "claimOrderHandleDetail",
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row;
            return [{
                label: this.$t('global.common.query', { defaultValue: "查看" }),
                show: true,
                params: id,
                operate: 'query'
            }]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getSelfmanageorgList', 'getCusproductList','getUserManageWarehouseList']),
        ToolsData() {
            return [{
                name: this.$t('global.common.export', { defaultValue: "导出" }),
                show: this.handleAuth('fbb.returnplan.export'),
                operate: "export",
            }]
        },
        SearchsData() {
            let widthStyle = 'width: 218px;'
            return [
                {
                    label: this.$t('fbb.alloment.client_organization',{defaultValue:'客户'}),
                    key: 'EQ_organizationId',
                    tag: 'Select',
                    show: true,
                    options: this.getSelfmanageorgList,
                    props: {
                        filterable: true,
                    },
                    style: 'width: 172px; margin-right:27px',
                },
                {
                    label: this.$t('', { defaultValue: "认领处理单号" }),
                    key: 'EQ_claimNo',
                    show: true,
                    tag: 'vInput',
                    style: 'width: 172px; margin-right:27px',
                },
                {
                    label: this.$t('', { defaultValue: "来源单号" }),
                    key: 'EQ_sourceNo',
                    show: true,
                    tag: 'vInput',
                    style: 'width: 172px; margin-right:27px',
                },
                {
                    label: this.$t('', { defaultValue: "认领单号" }),
                    key: 'EQ_claimPlanNo',
                    tag: 'vInput',
                    style: widthStyle,
                },
                {
                    label: this.$t('', { defaultValue: "状态" }),
                    key: 'EQ_status',
                    tag: 'Select',
                    options: this.getClaimOrderHandleOrderStatus.slice(1),
                    style: widthStyle,
                },
                {
                    label: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    key: 'EQ_orgWarehouseCode',
                    tag: 'Select',
                    options: this.getUserManageWarehouseList.map(item => {
                        return {
                            label: item.label,
                            value: item.attach.code
                        }
                    }),
                    props: {
                        filterable: true,
                    },
                    style: widthStyle,
                },
                {
                    label: this.$t('global.common.project', { defaultValue: "项目" }),
                    key: 'EQ_lineId',
                    tag: 'Select',
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle,
                },
                {
                    label: this.$t('global.common.createdtime', { defaultValue: "创建时间" }),
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: widthStyle,
                },
            ]
        },
        columns() {
            return [
                {
                    title: this.$t('global.common.actions', { defaultValue: "操作" }),
                    width: 100,
                    render: this.getOperateNodes
                },
                {
                    title: this.$t('fbb.alloment.client_organization',{defaultValue:'客户'}),
                    width: 100,
                    key: 'organizationId',
                    render: (h, { row }) => this.findRenderLabel(this.getSelfmanageorgList, row.organizationId)||'--'
                },
                {
                    title: this.$t('', { defaultValue: "认领处理单号" }),
                    key: 'claimNo',
                    render: (h, { row }) => {
                        return <div>
                            <a class="color-link" onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.claimNo || '--'}</a>
                            <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                        </div>
                    }
                },
                {
                    title: this.$t('', { defaultValue: "来源单号" }),
                    key: 'sourceNo',
                    render: (h, { row }) => {
                        return <div>{ row.sourceNo || '--'}</div>
                    }
                },
                {
                    title: this.$t('', { defaultValue: "认领单号" }),
                    key: 'claimPlanNo',
                    render: (h, { row }) => {
                        return <div>{ row.claimPlanNo || '--'}</div>
                    }
                },
                {
                    title: this.$t('', { defaultValue: '状态' }),
                    key: "status",
                    render: (h, { row }) => {
                        return <div>{ this.findRenderLabel( this.getClaimOrderHandleOrderStatus, row.status ) || '--'}</div>
                    }
                },
                {
                    title: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    key: 'orgWarehouseCode',
                    render:( h, { row })=>{
                        const wareHouse=this.getUserManageWarehouseList.filter(item=>item.attach.code === row.orgWarehouseCode)
                        return <div>{ wareHouse[0] ? wareHouse[0].label : '--'}</div>
                    }
                },
                {
                    title: this.$t('global.common.project', { defaultValue: "项目" }),
                    key: 'lineId',
                    render: (h, { row }) => this.findRenderLabel(this.getCusproductList, row.lineId)|| '--'
                },
                {
                    title: this.$t('global.common.updatedAt', { defaultValue: "更新时间" }),
                    key: 'updatedAt',
                }];
        },
    },
};




